import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './theme/ThemeContext';
import routes from './utils/routes';
import AuthProvider from './context/AuthContext';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import BackdropCircularProgressComponent from './components/BackdropCircularProgressComponent';
import ModalStrip from './components/ModalStrip';


const App: React.FC = () => {

  const router = createBrowserRouter(routes)

  return (
      <AuthProvider>
        <Provider store={store}>
        <ThemeProvider>
          <BackdropCircularProgressComponent />
          <ModalStrip />
          <RouterProvider router={router} />
        </ThemeProvider>
        </Provider>
      </AuthProvider>
  );
}

export default App;
